import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Announcement from './Announcement';
import Header from './Header';
import MobileMenu from './MobileMenu';
import SearchOverlay from './SearchOverlay';
import Footer from './Footer';
import MobileStickyBar from './MobileStickyBar';
import CartDrawer from './CartDrawer';
import { IconArrowUp } from '../common/Icons';

export default function Layout() {
  const [showTop, setShowTop] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [pathname]);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <Announcement />
      <Header />
      <MobileMenu />
      <SearchOverlay />
      <main role="main" id="MainContent">
        <Outlet />
      </main>
      <Footer />
      <MobileStickyBar />
      <CartDrawer />
      <button
        type="button"
        id="scroll-to-top-button"
        className={`sf__btn btn-scroll-top sf__btn-primary fixed z-50 bottom-[86px] items-center justify-center right-4 md:right-8 md:bottom-8 ${showTop ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="Scroll to top"
      >
        <IconArrowUp width={18} height={18} />
      </button>
    </>
  );
}
